<template>
    <footer class="footer-bar-wrap">
        <div class="footer-container">
            <img src="../assets/images/footer/footer_logo.png" class="footer-logo" alt="footer-logo">
            <p class="link-box">
                <router-link class="link-a" target="_blank" to="/policy">이용약관</router-link>
                <router-link class="link-a" target="_blank" to="/privacy">개인정보처리방침</router-link>
            </p>
            <p class="copyinfo">©2017 HYPERGRYPH CO., LTD  ©2019 YOSTAR LIMITED</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterBar",

    components: {

    },
    data: () => ({
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.footer-bar-wrap {
    height: auto !important;
    background: #141516;
    padding-bottom: pxTorem(140px);

    .footer-container {
        padding: pxTorem(50px) 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-top: 1px solid #535353; 
        border-bottom: 1px solid #535353; 
        
        .footer-logo {
            width: pxTorem(654px);
            margin-bottom: pxTorem(35px);
        }
        .link-box {
            margin-bottom: pxTorem(32px);
            font-size: 0;

            .link-a {
                font-family: "Microsoft YaHei";
                color: #fff;
                font-size: pxTorem(12px);

                &:not(:last-child) {
                    margin-right: pxTorem(38px);
                }
            }
        }
        .copyinfo {
            font-family: "Microsoft YaHei";
            color: #fff;
            font-size: pxTorem(12px);
        }
    }
}
</style>
